import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { useForm, Controller } from 'react-hook-form'
import { PanelGroup, Panel } from 'rsuite'
// import { Checkbox, CheckboxGroup } from 'rsuite';
import { IconButton, Icon, Message } from 'rsuite'
import { Row, Col } from 'rsuite'
import TargetGroupAndAreaForm from './TargetGroupAndAreaForm'
import TargetGroupAndAreaView from './TargetGroupAndAreaView'
import scrollToComponent from 'react-scroll-to-component'
import { startLoading, doneLoading } from '../../utils/loading'
import { getSchemaSidebar } from '../../redux/actions/sidebar'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import {
  updateTargetGroup,
  getProgressSearchTag,
  updateProgressSearchTag,
  saveProgressFeedback,
  updateProgressFeedback,
  deleteProgressFeedback,
  getTargetGroup,
} from '../../redux/actions/projectProgress'
import AreaTableForm from './AreaTableForm'
import TargetDep6Form from './TargetDep6Form'
import TargetDep6Table from './TargetDep6Table'
import AreaTableView from './AreaTableView'
import CommentForm from './CommentForm'
import CommentView from './CommentView'
import WarningMessage from '../../components/message/WarningMessage/WarningMessage'
import ButtonPanel from '../ButtonPanel'

export default function TargetGroupAndAreaWidget(props) {
  const { showCommandButton, schema, isEdit, onChangeIsEdit } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const { register, handleSubmit, watch, errors, control, setValue, clearErrors } = useForm()
  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const [formSchema, setFormSchema] = useState(schema)
  const [progressId, setProgressId] = useState()

  const [targetDep6MainList, setTargetDep6MainList] = useState([])
  const [targetDep6SubList, setTargetDep6SubList] = useState([])

  useEffect(() => {
    // let progressId = location.search.substring(1)
    let progressId = sessionStorage.getItem('param')?.substring(1)
    console.log('TargetGroupAndAreaWidget', schema, 'progressId', progressId)
    setProgressId(progressId)
    // setFormSchema(_schema)
  }, [schema])

  const handleGetSchema = async (projectId, progressId) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getTargetGroup(projectId, progressId)
      if (response) setFormSchema(response)
    } catch (e) {}
    doneLoading()
    setIsLoading(false)
  }

  const handleUpdateTargetGroup = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      const response = await updateTargetGroup(projectId, progressId, request)
      if (response.id) {
        setFormSchema(response)
        onChangeIsEdit(false)
        // await dispatch(getSchemaSidebar(projectId))
        setTargetDep6MainList([])
        setTargetDep6SubList([])
      } else {
        setIsError(true)
      }
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleCallCommentService = async (request, projectProgressId) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      if (request.value.value || request.value.id) {
        if (request.value.value) {
          let response

          if (request.value.id) {
            console.log('call update.')
            response = await updateProgressFeedback(projectId, projectProgressId, request)
          } else {
            console.log('call save.')
            response = await saveProgressFeedback(projectId, projectProgressId, request)
          }

          console.log('response', response)
          if (response) {
            onChangeIsEdit(false)
            let _schema = formSchema
            _schema.comment = response
            setFormSchema(_schema)
          } else {
            setIsError(true)
          }
        } else {
          let deleteResult = await deleteProgressFeedback(
            projectId,
            projectProgressId,
            request.value.id
          )

          if (deleteResult == 200) {
            let _schema = await getProgressSearchTag(projectId, projectProgressId)
            console.log('getProgressSearchTag', _schema)
            onChangeIsEdit(false)
            setFormSchema(_schema)
          } else {
            setIsError(true)
          }
        }
      }
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)
    // console.log('errors', errors)
    //console.log('formSchema', formSchema)

    // if (data[formSchema.criteriaList.name]) {
    //   formSchema.criteriaList.optionSelected = data[formSchema.criteriaList.name]
    // } else {
    //   formSchema.criteriaList.optionSelected = []
    // }

    console.log(formSchema)

    //create targetLists for post api
    let targetLists = []
    if (formSchema?.targetGroup?.criteriaList?.options)
      formSchema.targetGroup.criteriaList.options.forEach((item) => {
        data.optionSelected.forEach((selected) => {
          if (item.value === selected) {
            let _data = {
              id: item.value,
              value: item.numberOfPeople.value,
              description: item.detail.value,
            }
            targetLists.push(_data)
          }
        })
      })

    //generate new area list for update & add new
    let areaList = []
    console.log('formSchema.area.values', formSchema.area.values)
    formSchema.area.values.forEach((item) => {
      if (item.id.indexOf('ADD') != -1) {
        item.id = ''
      }
      areaList.push(item)
    })

    // add targetType
    let _targetDep6MainList = []
    if (targetDep6MainList && formSchema?.targetDep6?.targetDep6Main?.targetType)
      targetDep6MainList.forEach((item) => {
        item.targetType = formSchema.targetDep6.targetDep6Main.targetType
        if (item.id.indexOf('ADD') !== -1) {
          item.id = ''
        }
        _targetDep6MainList.push(item)
      })

    let _targetDep6SubList = []
    if (targetDep6MainList && formSchema?.targetDep6?.targetDep6Sub?.targetType)
      targetDep6SubList.forEach((item) => {
        item.targetType = formSchema.targetDep6.targetDep6Sub.targetType
        if (item.id.indexOf('ADD') !== -1) {
          item.id = ''
        }
        _targetDep6SubList.push(item)
      })

    let request = {
      id: schema.id,
      projectVersionId: projectId,
      userId: '',
      projectProgressId: progressId,
      //targetCriteria: data.targetCriteria,
      targetValue: targetLists,
      areaValues: areaList,
      targetDep6Value: _targetDep6MainList.concat(_targetDep6SubList),
    }
    console.log('request ', JSON.stringify(request))
    handleUpdateTargetGroup(request)

    //formSchema.targetGroup.criteriaList.optionSelected = data.optionSelected
  }

  const onTargetDep6MainSubmit = (data) => {
    console.log('onTargetDep6Main Submit', data)
    setTargetDep6MainList(data)
  }

  const onTargetDep6SubSubmit = (data) => {
    console.log('onTargetDep6Sub Submit', data)
    setTargetDep6SubList(data)
    console.log(formSchema)
  }

  const onSubmitComment = (data) => {
    console.log('onSubmitComment', data)

    const request = {
      id: formSchema.id,
      projectVersionId: projectId,
      projectProgressId: progressId,
      masterSubjectId: formSchema.comment.masterSubjectId,
      value: {
        id: formSchema.comment.id,
        value: data.comment,
      },
    }

    console.log('request body', request)
    handleCallCommentService(request, progressId)
  }

  const TargetGroupFormEdit = (
    <>
      {formSchema?.targetGroup && (
        <TargetGroupAndAreaForm
          schema={formSchema}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
        />
      )}

      {formSchema?.targetDep6?.targetDep6Main && (
        <>
          <p>{formSchema.targetDep6.targetDep6Main.header}</p>
          <TargetDep6Form
            key="key-tagetDep6"
            schema={formSchema.targetDep6.targetDep6Main}
            // register={register}
            // Controller={Controller}
            // control={control}
            // errors={errors}
            // setValue={setValue}
            // clearErrors={clearErrors}
            onAddEditSuccess={onTargetDep6MainSubmit}
            //onDelete={handleDelete}
            scrollToComponent={() => {
              scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
            }}
            isError={isError}
            //isDeleteError={isDeleteError}
            loading={isLoading}
          />
        </>
      )}

      {formSchema?.targetDep6?.targetDep6Sub && (
        <>
          <p>{formSchema.targetDep6.targetDep6Sub.header}</p>
          <TargetDep6Form
            key="key-tagetDep6"
            schema={formSchema.targetDep6.targetDep6Sub}
            // register={register}
            // Controller={Controller}
            // control={control}
            // errors={errors}
            // setValue={setValue}
            // clearErrors={clearErrors}
            onAddEditSuccess={onTargetDep6SubSubmit}
            //onDelete={handleDelete}
            scrollToComponent={() => {
              scrollToComponent(section, { offset: 500, align: 'top', duration: 500 })
            }}
            isError={isError}
            //isDeleteError={isDeleteError}
            loading={isLoading}
          />
        </>
      )}

      <br />
      <AreaTableForm schema={formSchema.area} isDep6={!formSchema.targetGroup || false} />
    </>
  )

  const TargetGroupFormView = (
    <>
      {formSchema?.targetGroup && <TargetGroupAndAreaView schema={formSchema} />}
      {formSchema?.targetDep6?.targetDep6Main && (
        <>
          <p>{formSchema.targetDep6.targetDep6Main.header}</p>
          <br />
          <TargetDep6Table
            isEdit={false}
            schema={formSchema.targetDep6?.targetDep6Main}
            dataList={formSchema.targetDep6?.targetDep6Main?.target?.values}
          />
        </>
      )}
      <br />
      <br />
      {formSchema?.targetDep6?.targetDep6Sub && (
        <>
          <p>{formSchema.targetDep6.targetDep6Sub.header}</p>
          <br />
          <TargetDep6Table
            isEdit={false}
            schema={formSchema.targetDep6.targetDep6Sub}
            dataList={formSchema.targetDep6?.targetDep6Sub?.target?.values}
          />
        </>
      )}
      <br />
      <br />
      <AreaTableView schema={formSchema} isDep6={!formSchema.targetGroup || false} />
    </>
  )

  return (
    <Panel
      shaded
      header={formSchema.header}
      defaultExpanded
      collapsible
      ref={(section) => {
        setSection(section)
      }}
    >
      {formSchema?.comment?.enableEdit ? (
        <>
          <div>{TargetGroupFormView}</div>
          <hr />
          {isEdit ? (
            <CommentForm
              schema={formSchema.comment}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />
          ) : (
            <div>
              <CommentView schema={formSchema.comment} />
            </div>
          )}
        </>
      ) : (
        <>
          <WarningMessage style={{ marginBottom: 10 }} message={formSchema?.comment?.value} />
          {isEdit ? TargetGroupFormEdit : TargetGroupFormView}
          {showCommandButton && <hr />}
        </>
      )}

      {showCommandButton && (
        <>
          <hr />
          <ButtonPanel
            showCommandButton={showCommandButton}
            isDisabled={isLoading}
            isEdit={isEdit}
            isError={isError}
            buttonText={
              formSchema?.comment?.enableEdit ? formSchema?.comment?.buttonText : formSchema.header
            }
            onSave={handleSubmit(formSchema.comment?.enableEdit ? onSubmitComment : onSubmit)}
            onCancel={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
              handleGetSchema(projectId, progressId)
            }}
            onEdit={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
              scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
            }}
          />
        </>
      )}

      {/* {!isEdit && showCommandButton && (
        <IconButton
          onClick={() => {
            onChangeIsEdit(!isEdit)
            scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
          }}
          icon={<Icon appearance="ghost" icon="edit" />}
        >
          แก้ไข{formSchema.header}
        </IconButton>
      )}

      {isEdit && (
        <div>
          {isError && (
            <Row style={{ marginBottom: '1em' }}>
              <Message showIcon type="error" description={'เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ'} />
            </Row>
          )}

          <SaveButton onClick={handleSubmit(onSubmit)} disabled={isLoading}></SaveButton>
          <CancelButton
            onClick={() => {
              onChangeIsEdit(!isEdit)
              setIsError(false)
              console.log(formSchema)
            }}
            disabled={isLoading}
          ></CancelButton>
        </div>
      )} */}
    </Panel>
  )
}
